import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import MerchantInvoiceSection from "../../Sections/Invoice/index";

const InvoiceComponent = () => {
    return (
        <Dashboard sectionName={<MerchantInvoiceSection />}/>
    );
};

export default InvoiceComponent;